import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, Input, HostListener, Optional, Host, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/forms';

class ClickOutsideDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new EventEmitter();
    }
    onClick(targetElement) {
        const ignoreClick = !document.contains(targetElement)
            || targetElement.closest('[ignoreOutsideClick]')
            || (this.ignoreClickSelector && document.querySelector(this.ignoreClickSelector)?.contains(targetElement));
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside && !ignoreClick) {
            this.clickOutside.emit(null);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ClickOutsideDirective, selector: "[clickOutside]", inputs: { ignoreClickSelector: "ignoreClickSelector" }, outputs: { clickOutside: "clickOutside" }, host: { listeners: { "document:click": "onClick($event.target)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[clickOutside]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { clickOutside: [{
                type: Output
            }], ignoreClickSelector: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }] } });

class ErrorValidationDirective {
    constructor(formControlName, ngControl, renderer, elementRef) {
        this.formControlName = formControlName;
        this.ngControl = ngControl;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.errorValidation = '';
        this.validationTranslate = new Map();
        this.touched = false;
        this.initValidationTranslate();
    }
    initValidationTranslate() {
        this.validationTranslate.set('required', () => 'Campo requerido');
        this.validationTranslate.set('email', () => 'E-mail inválido');
        this.validationTranslate.set('minlength', (obj) => `Tamanho mínimo é ${obj.requiredLength}`);
        this.validationTranslate.set('maxlength', (obj) => `Tamanho máximo é ${obj.requiredLength}`);
        this.validationTranslate.set('min', (obj) => `Valor mínimo é ${obj.min}`);
        this.validationTranslate.set('max', (obj) => `Valor máximo é ${obj.max}`);
        this.validationTranslate.set('mask', (obj) => `Valor incompativel com a máscara esperada: ${obj.requiredMask}`);
    }
    get control() {
        return this.formControlName?.control || this.ngControl?.control || null;
    }
    onFocusOut(event) {
        this.touched = true;
        this.updateValidation();
    }
    ngOnInit() {
        if (this.control) {
            this.subscription = this.control.statusChanges.subscribe(() => {
                this.updateValidation();
            });
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    translateKey(key, obj) {
        const translate = this.validationTranslate.get(key);
        if (translate) {
            return translate(obj);
        }
        return obj;
    }
    removePreviousValidation() {
        this.renderer.removeClass(this.elementRef.nativeElement, 'error');
        this.elementRef.nativeElement.parentNode.querySelectorAll('span.help-message').forEach((element) => {
            element.remove();
        });
    }
    updateValidation() {
        this.removePreviousValidation();
        if (this.control?.errors && this.control?.dirty && this.touched) {
            Object.keys(this.control.errors).forEach(key => {
                const errorMessage = document.createTextNode(this.translateKey(key, (this.control.errors || [])[key]));
                const errorSpan = this.renderer.createElement('span');
                ['help-message'].forEach(className => this.renderer.addClass(errorSpan, className));
                this.renderer.appendChild(errorSpan, errorMessage);
                this.renderer.appendChild(this.elementRef.nativeElement.parentNode, errorSpan);
                this.renderer.addClass(this.elementRef.nativeElement, 'error');
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorValidationDirective, deps: [{ token: i1.FormControlName, optional: true }, { token: i1.NgControl, optional: true }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ErrorValidationDirective, selector: "[errorValidation]", inputs: { errorValidation: "errorValidation", touched: "touched" }, host: { listeners: { "focusout": "onFocusOut($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorValidationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[errorValidation]'
                }]
        }], ctorParameters: () => [{ type: i1.FormControlName, decorators: [{
                    type: Optional
                }] }, { type: i1.NgControl, decorators: [{
                    type: Optional
                }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { errorValidation: [{
                type: Input
            }], touched: [{
                type: Input
            }], onFocusOut: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

class SwitchCasesDirective {
    constructor(viewContainer, templateRef, ngSwitch) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this._created = false;
        this.ngSwitch = ngSwitch;
        this.ngSwitch._defaultUsed = true;
    }
    ngOnInit() {
        this.ngSwitch._defaultUsed = false;
        (this.ngMultipleSwitchCase || []).forEach(() => this.ngSwitch._addCase());
    }
    ngDoCheck() {
        let enforce = false;
        (this.ngMultipleSwitchCase || []).forEach(value => enforce = this.ngSwitch._matchCase(value) || enforce);
        this.enforceState(enforce);
    }
    enforceState(created) {
        if (created && !this._created) {
            this._created = true;
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else if (!created && this._created) {
            this._created = false;
            this.viewContainer.clear();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchCasesDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i1$1.NgSwitch, host: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SwitchCasesDirective, selector: "[ngMultipleSwitchCase]", inputs: { ngMultipleSwitchCase: "ngMultipleSwitchCase" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchCasesDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngMultipleSwitchCase]'
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i1$1.NgSwitch, decorators: [{
                    type: Host
                }] }], propDecorators: { ngMultipleSwitchCase: [{
                type: Input
            }] } });

class TypedTemplateDirective {
    constructor(contentTemplate) {
        this.contentTemplate = contentTemplate;
    }
    static ngTemplateContextGuard(dir, ctx) { return true; }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TypedTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: TypedTemplateDirective, selector: "ng-template[typedTemplate]", inputs: { typeToken: ["typedTemplate", "typeToken"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TypedTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'ng-template[typedTemplate]' }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { typeToken: [{
                type: Input,
                args: ['typedTemplate']
            }] } });

class AppearDirective {
    constructor(element) {
        this.element = element;
        this.scrollContainer = null;
        this.appear = new EventEmitter();
    }
    ngAfterViewInit() {
        const options = {
            root: this.scrollContainer,
            rootMargin: '0px',
            threshold: 0.1,
        };
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.appear.next();
                }
            });
        }, options);
        this.observer.observe(this.element.nativeElement);
    }
    ngOnDestroy() {
        this.observer?.disconnect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppearDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: AppearDirective, selector: "[appear]", inputs: { scrollContainer: "scrollContainer" }, outputs: { appear: "appear" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppearDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appear]',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { scrollContainer: [{
                type: Input
            }], appear: [{
                type: Output
            }] } });

class DisabledResetDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.disabledReset = false;
    }
    ngOnChanges(changes) {
        if (changes['disabledReset']) {
            const action = this.disabledReset ? 'disable' : 'enable';
            if (this.ngControl.control) {
                this.ngControl.control[action]();
                if (this.disabledReset) {
                    this.ngControl.control.reset();
                    this.ngControl.control.markAsPristine();
                    this.ngControl.control.markAsUntouched();
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisabledResetDirective, deps: [{ token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: DisabledResetDirective, selector: "[disabledReset]", inputs: { disabledReset: "disabledReset" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisabledResetDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[disabledReset]'
                }]
        }], ctorParameters: () => [{ type: i1.NgControl }], propDecorators: { disabledReset: [{
                type: Input
            }] } });

class DelayedIfDirective {
    set delayedIf(config) {
        if (config.render) {
            setTimeout(() => this.viewContainer.createEmbeddedView(this.templateRef), config.in);
        }
        else {
            setTimeout(() => this.viewContainer.clear(), config.out);
        }
    }
    constructor(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DelayedIfDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: DelayedIfDirective, selector: "[delayedIf]", inputs: { delayedIf: "delayedIf" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DelayedIfDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[delayedIf]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }], propDecorators: { delayedIf: [{
                type: Input
            }] } });

class NgxtForDirective {
    constructor(templateRef, viewContainer, differs) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.differs = differs;
        this.items = [];
        this.viewRefsMap = new Map();
        this.itemsAtOnce = 10;
        this.intervalLength = 50;
    }
    set ngxtForOf(items) {
        this.items = items;
        if (items) {
            this._diffrence = this.differs.find(items).create();
        }
        this.viewContainer.clear();
    }
    ngDoCheck() {
        if (this._diffrence) {
            const changes = this._diffrence.diff(this.items);
            if (changes) {
                const itemsAdded = [];
                changes.forEachAddedItem(item => {
                    itemsAdded.push(item);
                });
                this.progressiveRender(itemsAdded);
                changes.forEachRemovedItem(item => {
                    const mapView = this.viewRefsMap.get(item.item);
                    const viewIndex = this.viewContainer.indexOf(mapView);
                    this.viewContainer.remove(viewIndex);
                    this.viewRefsMap.delete(item.item);
                });
            }
        }
    }
    progressiveRender(items) {
        let interval;
        let start = 0;
        let end = start + this.itemsAtOnce;
        if (end > items.length) {
            end = items.length;
        }
        this.renderItems(items, start, end);
        interval = setInterval(() => {
            start = end;
            end = start + this.itemsAtOnce;
            if (end > items.length) {
                end = items.length;
            }
            this.renderItems(items, start, end);
            if (start >= items.length) {
                clearInterval(interval);
            }
        }, this.intervalLength);
    }
    renderItems(items, start, end) {
        items.slice(start, end).forEach(item => {
            const embeddedView = this.viewContainer.createEmbeddedView(this.templateRef, {
                $implicit: item.item
            }, item.currentIndex || 0);
            this.viewRefsMap.set(item.item, embeddedView);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgxtForDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgxtForDirective, selector: "[ngxtFor]", inputs: { ngxtForOf: "ngxtForOf", itemsAtOnce: ["ngxtForItemsAtOnce", "itemsAtOnce"], intervalLength: ["ngxtForIntervalLength", "intervalLength"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgxtForDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngxtFor]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i0.IterableDiffers }], propDecorators: { ngxtForOf: [{
                type: Input,
                args: ['ngxtForOf']
            }], itemsAtOnce: [{
                type: Input,
                args: ['ngxtForItemsAtOnce']
            }], intervalLength: [{
                type: Input,
                args: ['ngxtForIntervalLength']
            }] } });

class DirectivesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, declarations: [ClickOutsideDirective,
            SwitchCasesDirective,
            ErrorValidationDirective,
            TypedTemplateDirective,
            AppearDirective,
            DisabledResetDirective,
            DelayedIfDirective,
            NgxtForDirective], imports: [CommonModule], exports: [ClickOutsideDirective,
            SwitchCasesDirective,
            ErrorValidationDirective,
            TypedTemplateDirective,
            AppearDirective,
            DisabledResetDirective,
            DelayedIfDirective,
            NgxtForDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ClickOutsideDirective,
                        SwitchCasesDirective,
                        ErrorValidationDirective,
                        TypedTemplateDirective,
                        AppearDirective,
                        DisabledResetDirective,
                        DelayedIfDirective,
                        NgxtForDirective
                    ],
                    exports: [
                        ClickOutsideDirective,
                        SwitchCasesDirective,
                        ErrorValidationDirective,
                        TypedTemplateDirective,
                        AppearDirective,
                        DisabledResetDirective,
                        DelayedIfDirective,
                        NgxtForDirective
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AppearDirective, ClickOutsideDirective, DelayedIfDirective, DirectivesModule, DisabledResetDirective, ErrorValidationDirective, NgxtForDirective, SwitchCasesDirective, TypedTemplateDirective };
